export const CONTACT_PHONE = " +1 (213) 375-0476"
export const CONTACT_PHONE_HREF = "+12133750476"
export const IOS_DOWNLOAD_HREF = "https://apps.apple.com/app/6474152936"
